import {ADD_TO_HOME_STATE, INSTALLED_GAMES_LS_KEY} from './constant';

const keysToKeep = [
  new RegExp(`\\d+_${ADD_TO_HOME_STATE}`),
  new RegExp(`^${INSTALLED_GAMES_LS_KEY}$`),
];

export function clearLocalStorage() {
  for (let i = localStorage.length - 1; i >= 0; i--) {
    const key = localStorage.key(i);
    if (key && !keysToKeep.some((k) => k.test(key))) {
      localStorage.removeItem(key);
    }
  }
}
